import React, { Component } from 'react'
import Axios from 'axios'
import moment from 'moment';
import { Link } from 'react-router-dom';



class VerificarDuplicadas extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pedidos: [],
      pedidosSimilares: [],
      cartelasPedidos: [],
      agrupados: [],
      transacoes: [],
      transacoesFalsas: [],
      lotes: [],
      cartelas: []
    }
    this.getPedidosSimilares = this.getPedidosSimilares.bind(this)
    this.agruparSimilares = this.agruparSimilares.bind(this)
    this.deletarPedido = this.deletarPedido.bind(this)
    this.deletarTransacao = this.deletarTransacao.bind(this)
    this.getTodosPedidos()
    this.getTodosTransacoes()
    // this.deletarPedidosVazios()
    this.listarLotes()

  }
  async deletarpedidos2() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/deletar-por-cliente", { id: "5ef8e0c67648692c2d5790f9" });
    } catch (err) {
      console.log(err);
    }
  };

  async deletarTransacao2() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("transacoes/deletar-por-cliente", { id: "5ef8e0c67648692c2d5790f9" });
    } catch (err) {
      console.log(err);
    }
  };

  async listarLotes() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("lotes/all-lotes", {});

      this.setState({ lotes: response.data });

      this.montarCartelas()
    } catch (err) {
      console.log(err);
    }
  };

  compararCodigo(a, b) {
    if (a.codigo > b.codigo) {
      return 1;
    }
    if (a.codigo < b.codigo) {
      return -1;
    }

    return 0
  }

  montarCartelas() {
    var cartelas = []
    this.state.lotes.map(lote => {
      lote.cartelas.map(cartela => {
        cartelas.push(cartela)
      })
    })
    this.setState({ cartelas: cartelas.sort(this.compararCodigo) })
  }

  async deletarPedidosVazios() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/deletar-vazios", {});
    } catch (err) {
      console.log(err);
    }
  }

  async getTodosPedidos() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("pedidos/listar-2", {});
      this.setState({ pedidos: response.data.reverse() });
      if (response.data)
        this.getTodasCartelas()
    } catch (err) {
      console.log(err);
    }
  }

  async getTodosTransacoes() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("transacoes/listar-todas", {});
      this.setState({ transacoes: response.data.reverse() });
    } catch (err) {
      console.log(err);
    }
  }

  getTodasCartelas() {
    var cartelasPedidos = []
    this.state.pedidos.map(pedido => {
      pedido.cartelas.map(cartela => {
        // if(pedido.recebido && pedido.cartelas.length == 1)//Depois eu tiro
        cartelasPedidos.push({ cartela, pedido })
      })
    })
    this.setState({ cartelasPedidos: cartelasPedidos.sort(this.compararPedidos) })
  }

  async getPedidosSimilares() {
    var pedidosSimilares = []
    this.state.cartelasPedidos.map(cp => {
      this.state.pedidos.map(pedido => {
        pedido.cartelas.map(cartela => {
          if (cp.cartela.codigo == cartela.codigo)
            pedidosSimilares.push({ cartela, pedido })
        })
      })
    })
    this.setState({ pedidosSimilares: pedidosSimilares.sort(this.compararPedidos) })

  }

  compararPedidos(a, b) {
    if (a.cartela.codigo > b.cartela.codigo) {
      return 1;
    }
    if (a.cartela.codigo < b.cartela.codigo) {
      return -1;
    }

    return 0
  }






  agruparSimilares() {
    //   this.state.pedidosSimilares.map(cp => {

    //   })
  }

  async deletarPedido(e) {
    var item = this.state.cartelasPedidos[parseInt(e.target.accessKey)]
    this.state.cartelasPedidos.splice(parseInt(e.target.accessKey), 1)
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/deleta", { id: item.pedido._id });
      const response2 = await axiosInstance.post("transacoes/deleta", { id: item.pedido.transacaoId._id });

    } catch (err) {
      console.log(err);
    }

    this.setState({ cartelasPedidos: this.state.cartelasPedidos })
  }


  async deletarTransacao(e) {
    var item = JSON.parse(e.target.accessKey)
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("transacoes/deleta", { id: item._id });

    } catch (err) {
      console.log(err);
    }
  }

  async deletarTransacaoFalsa(item) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("transacoes/deleta", { id: item._id });
      console.log(response.data)

    } catch (err) {
      console.log(err);
    }
  }

  comparaAdjadcentes(e) {
    var index = e;
    var lastIndex = index - 1;
    var nextIndex = index + 1;
    var item = this.state.cartelasPedidos[index];
    if (this.state.cartelasPedidos[lastIndex] && this.state.cartelasPedidos[nextIndex] &&
      (this.state.cartelasPedidos[index - 1].cartela.codigo == item.cartela.codigo ||
        this.state.cartelasPedidos[index + 1].cartela.codigo == item.cartela.codigo))
      return true;
    else {
      return false;
    }
  }

  comparaTransAdjadcentes(e) {
    var index = e;
    var lastIndex = index - 1;
    var nextIndex = index + 1;
    var item = this.state.transacoes[index];
    if (this.state.transacoes[lastIndex] && this.state.transacoes[nextIndex] &&
      (this.state.transacoes[index - 1].documento == item.documento ||
        this.state.transacoes[index + 1].documento == item.documento))
      return true;
    else {
      return false;
    }
  }

  async getPedidoPorTransacao(e) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/por-transacao", {
        transacaoId: e._id
      });
      return response.data
    } catch (err) {
      console.log(err);
    }
  };

  separaTransacoesFalsas() {
    var transacoesClone = [...this.state.transacoes];
    this.state.pedidos.map(pedido => {
      this.state.transacoes.map((transacao, index) => {
        if (pedido.transacaoId != undefined && transacao._id == pedido.transacaoId._id) {
          transacoesClone[index] = null;
        }
      })
    })
    this.setState({ transacoesFalsas: transacoesClone })
    this.deletarTransacoesFalsas(transacoesClone)
  }

  deletarTransacoesFalsas(transacoesFalsas) {
    transacoesFalsas.map(t => {
      if (t != null) {
        this.deletarTransacaoFalsa(t)
      }
    })
  }

  render() {
    return (

      <div className="container">
        <button onClick={this.separaTransacoesFalsas.bind(this)}>SEPARAR</button>
        <h1>{this.state.pedidos.length}</h1>
        <h1>{this.state.transacoes.length}</h1>
        <h1>{this.state.transacoesFalsas.length}</h1>
        {/* <h1>{this.state.cartelas ? this.state.cartelas.length : '0'}</h1> */}
        {/* <button className="btn-fill btn btn-danger" onClick={this.getPedidosSimilares}>Buscar Similares</button>
                <button className="btn-fill btn btn-danger" onClick={this.agruparSimilares}>Agrupar Similares</button>
                <table class="table">
                <thead class="thead-dark">
                    <tr>
                    <th scope="col">Pedido</th>
                    <th scope="col">Cartela</th>
                    <th scope="col">Lote</th>
                    <th scope="col">Recebido</th>
                    <th scope="col">Quantidade</th>
                    <th scope="col">Deletar</th>
                    </tr>
                </thead>
                <tbody>
                {this.state.cartelasPedidos.map((item,index) => {
                   return <tr>
                    <th scope="row">{item.pedido.codigo}</th>
                    <td>{item.cartela.codigo}</td>
                  <td>{item.pedido.loteId? item.pedido.loteId.codigo : "0"}</td>
                    <td>{item.pedido.recebido? 'SIM' : 'NÃO'}</td>
                    <td>{item.pedido.cartelas.length}</td>
                    <td><button  class={this.comparaAdjadcentes(index)? "btn-fill btn btn-danger" : "collapse"} accessKey={index} onClick={this.deletarPedido}>Deletar</button></td>
                    </tr>
                })}

                </tbody>
                </table> */}


        <table class="table">
          <thead class="thead-dark">
            <tr>
              <th scope="col">documento</th>
              <th scope="col">id</th>
              <th scope="col">valor</th>
            </tr>
          </thead>
          <tbody>
            {this.state.transacoesFalsas.map((item, index) => {
              if (item != null)
                return <tr>
                  <td >{item.documento}</td>
                  <td >{item._id}</td>
                  <td >{item.valor}</td>
                  <td ><button accessKey={JSON.stringify(item)} onClick={this.deletarTransacao.bind(this)}>DELETAR</button></td>

                </tr>
            })}

          </tbody>
        </table>

      </div>
    )
  }
}

export default VerificarDuplicadas